import React from 'react';
import cx from 'classnames';

type OuterGrayContainerProps = React.HTMLAttributes<HTMLDivElement> & {
  children?: React.ReactNode;
  className?: string;
  heading?: React.ReactNode;
  hidePadding?: boolean;
};

const OuterGrayContainer: React.FC<OuterGrayContainerProps> = ({
  children,
  className,
  heading,
  hidePadding,
  id,
}) => {
  const containerCx = cx(
    'OuterGrayContainer rounded-3xl sm:bg-pl-gray-background mb-4 lg:mb-8',
    hidePadding ? 'p-0 lg:p-8' : 'p-4 lg:p-8',
    className
  );
  return (
    <div className={containerCx} id={id}>
      {heading}
      {children}
    </div>
  );
};

export default OuterGrayContainer;
